import Swiper from 'swiper/bundle';

import './component.scss'

export class Banners
{

	constructor(id, params, result)
	{
		this.id = id
		this.params = params
		this.result = result
		this.$component = document.getElementById(this.id)

		this.init()
	}

	init()
	{
		this.initSwiper()
		this.initEvents()
		this.playActiveVideos()
	}

	initSwiper()
	{
		this.swiper = new Swiper('.js-swiper-banners', {
			spaceBetween: 20,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
		})
	}

	initEvents()
	{
		this.swiper.on('slideChangeTransitionStart', () => {
			this.pauseInActiveVideos()
		})
		this.swiper.on('slideChangeTransitionEnd', () => {
			this.playActiveVideos()
		})
	}

	pauseInActiveVideos()
	{
		let $elements = this.$component.querySelectorAll('video')

		for (let $video of $elements) {
			$video.pause()
		}
	}

	playActiveVideos()
	{
		let $activeVideo = this.$component.querySelector('.swiper-slide-active').querySelector('video')

		if (!$activeVideo) {
			return
		}

		$activeVideo.play()
	}

}
